import {
  ZodEffects,
  ZodNullable,
  ZodObject,
  ZodRawShape,
  ZodType,
  ZodTypeDef,
} from 'zod/v3';
import { isIsoDate, ISODate } from '../../dateUtils';

export interface RawSchemaShapeWithValidToAndValidFrom extends ZodRawShape {
  validFrom:
    | ZodType<ISODate, ZodTypeDef, ISODate>
    | ZodNullable<ZodType<ISODate, ZodTypeDef, ISODate>>
    | ZodEffects<ZodNullable<any>>;
  validTo:
    | ZodType<ISODate, ZodTypeDef, ISODate>
    | ZodNullable<ZodType<ISODate, ZodTypeDef, ISODate>>
    | ZodEffects<ZodNullable<any>>;
}

export const transformToValidPeriod = <
  T extends RawSchemaShapeWithValidToAndValidFrom,
>(
  schema: ZodObject<T>,
) =>
  schema.transform((data) => {
    const { validFrom, validTo, ...rest } = data;
    return {
      ...rest,
      validPeriod: [validFrom, validTo] as [
        Exclude<typeof validFrom, undefined>,
        Exclude<typeof validTo, undefined>,
      ],
    };
  });

export const transformToValidFromAndValidTo = <T extends ZodRawShape>(
  schema: ZodObject<T>,
) =>
  schema.transform(({ validPeriod, ...rest }) => ({
    ...rest,
    validFrom: isIsoDate(validPeriod[0]) ? validPeriod[0] : null,
    validTo: isIsoDate(validPeriod[1]) ? validPeriod[1] : null,
  }));
